/*
 * @Author: klein
 * @Date: 2021-10-22 14:30:13
 * @Description:
 * @LastEditors: Klein
 * @LastEditTime: 2021-12-21 11:29:52
 * @FilePath: \planApp\src\common\checkuser.js
 */
import Apollo from '../vue-apollo'
import {
  PAYMENTMETHODLIST,
  GET_CUSTOMERPORTAL,
  GET_NAMES,
  GET_SUBS,
  GET_PLAN_PRICE,
  PaymentMethodInfoByIntentId,
  WhiteList,
  SKUTOKENLIST
} from '../queries'
import {
  subscriptionNow,
  cancelSubscription,
  checkChannel,
  createSetupIntent,
  setDefaultPaymentMethod,
  CheckoutAddon,
  addOrUpdateGroupInfo,
  CheckoutSubForOdoo,
  updateSkuTokenInfo,
  addSkuTokenInfo,
  delSkuTokenInfo,
  addNewSkuTokenInfo,
  editFormulaInfo,
  addNewPlan,
  deletePlanGQL
} from '../mutation'
// import { Message } from "element-ui";
export const checkSub = (params, _this) => {
  return new Promise((resolve) => {
    Apollo.defaultClient.query({
      query: PAYMENTMETHODLIST,
      variables: params,
      fetchPolicy: 'network-only'
    }).then(({ data }) => {
      if (data.paymentMethodList && data.paymentMethodList.length) {
        // 可以免费
        // this.subscriptionNow()
        resolve('canCharge')
      } else {
        // handlecustomerPortal(params, _this)
        handlePayment(params, _this)
        resolve('customerPortal')
      }
      // // unbilledCharges 未支付数量
      // // cardStatus 卡状态
      // if(data.customer && data.customer.cardStatus === 'VALID' && data.customer.unbilledCharges == 0) {
      //   // 可以免费
      //   // this.subscriptionNow()
      //   resolve('canCharge')
      // }else {
      //   handlecustomerPortal(params)
      //   resolve('customerPortal')
      // }
    })
  })
}

// 获取clientSecret 打开添加卡的弹窗
export const handlePayment = (params, _this) => {
  Apollo.defaultClient.mutate({
    mutation: createSetupIntent,
    variables: params,
    fetchPolicy: 'no-cache'
  }).then(({ data }) => {
    _this.$payment.open(data.createSetupIntent.clientSecret, (type) => {
      console.log('type', type)
      type === 'success' && setDefault(params)
    })
  })
}

// 绑完卡 通知后台
export const setDefault = (params) => {
  Apollo.defaultClient.mutate({
    mutation: setDefaultPaymentMethod,
    variables: params,
    fetchPolicy: 'no-cache'
  }).then(({ data }) => {
    console.log(data)
  })
}
// 打开管理页面
export const handlecustomerPortal = (params) => {
  Apollo.defaultClient.query({
    query: GET_CUSTOMERPORTAL,
    variables: params,
    fetchPolicy: 'network-only'
  }).then(({ data }) => {
    window.open(data.customerPortal.url)
  })
}

// chargebee 的管理页面 废弃
export const openCustomerPortal = (url) => {
  const cbInstance = window.Chargebee.getInstance()
  cbInstance.openCheckout({
    hostedPage: () => new Promise((resolve) => resolve({ url })),
    step: (step) => {
      console.log(step)
    },
    success: (id) => {
      console.log(id)
    },
    close: () => {
      console.log('close')
    }
  })
}

// 创建或者修改sub
export const handleNewSub = (params, _this) => new Promise((resolve, reject) => {
  Apollo.defaultClient.mutate({
    mutation: subscriptionNow,
    variables: params,
    fetchPolicy: 'no-cache'
  }).then(({ data }) => {
    console.log(data)
    if (!data.checkoutSubscription) return false
    const info = data.checkoutSubscription.statusDescription || data.checkoutSubscription.status
    if (data.checkoutSubscription.status == 'PAID' || data.checkoutSubscription.status == 'paid') {
      resolve({
        info: 'paySuccess',
        amountPaid: data.checkoutSubscription.amountPaid,
        checkoutSubscription: data.checkoutSubscription
      })
    } else if (data.checkoutSubscription.status == 'POS-PAY') {
      resolve({
        info: 'POST-PAY',
        amountPaid: data.checkoutSubscription.amountPaid,
        checkoutSubscription: data.checkoutSubscription
      })
    } else if (data.checkoutSubscription.status == 'NO-CARD') {
      const { customerId, product } = params
      const payParams = { customerId, product }
      handlePayment(payParams, _this)
      reject({ info, type: 'NO-CARD' })
    } else if (data.checkoutSubscription.redirect && data.checkoutSubscription.redirect.iframeSrc) {
      window.open(data.checkoutSubscription.redirect.iframeSrc)
      // openCustomerPortal(data.checkoutSubscription.redirect.iframeSrc)
      reject({ info, type: 'REDIRECT' })
    } else {
      // Message.error('checkoutSubscription faild')
      reject({ info })
    }
  }).catch(error => {
    try {
      const { extensions } = error.graphQLErrors[0]
      console.log(extensions)
      const codes = ['80E00144', '80E00116']
      if (extensions && extensions.errorCode && codes.includes(extensions.errorCode)) {
        reject({ info: 'Please settle any pending invoices', type: 'failedInvoices' })
      } else {
        reject({ info: 'checkoutSubscription error' })
      }
    } catch (err) {
      console.log(err)
      reject({ info: 'checkoutSubscription error' })
    }
  })
})

export const checkoutAddon = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: CheckoutAddon,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}

// 查询 已经 订阅
export const userHasSubscription = (params) => {
  return Apollo.defaultClient.query({
    query: GET_SUBS,
    variables: params,
    fetchPolicy: 'network-only'
  })
}

// 取消订阅
export const cancelSub = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: cancelSubscription,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}

// check 能否降级
export const checkReduce = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: checkChannel,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}

//  查询价格
export const queryPrice = (params) => {
  return Apollo.defaultClient.query({
    query: GET_PLAN_PRICE,
    variables: params,
    fetchPolicy: 'network-only'
  })
}

//  查询价格
export const getPlans = (params) => {
  return Apollo.defaultClient.query({
    query: GET_NAMES,
    variables: params,
    fetchPolicy: 'network-only'
  })
}

//  查询价格
export const paymentMethodInfoByIntentId = (params) => {
  return Apollo.defaultClient.query({
    query: PaymentMethodInfoByIntentId,
    variables: params,
    fetchPolicy: 'network-only'
  })
}

// 查询白名单
export const queryWhiteList = (params) => {
  return Apollo.defaultClient.query({
    query: WhiteList,
    variables: params,
    fetchPolicy: 'network-only'
  })
}

export const submitAddWhiteList = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: addOrUpdateGroupInfo,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}

export const querySkuList = (params) => {
  return Apollo.defaultClient.query({
    query: SKUTOKENLIST,
    variables: params,
    fetchPolicy: 'network-only'
  })
}

export const updateSkuToken = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: updateSkuTokenInfo,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}

export const addSkuToken = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: addSkuTokenInfo,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}

export const delSkuToken = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: delSkuTokenInfo,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}

export const addNewSkuToken = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: addNewSkuTokenInfo,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}

export const editFormula = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: editFormulaInfo,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}
// 创建或者修改sub
export const checkoutSubForOdoo = (params) => new Promise((resolve, reject) => {
  Apollo.defaultClient.mutate({
    mutation: CheckoutSubForOdoo,
    variables: params,
    fetchPolicy: 'no-cache'
  }).then(({ data, errors }) => {
    console.log(data)
    if (data && data.checkoutSubForOdoo) {
      if (data.checkoutSubForOdoo.status == 'PAID') {
        resolve({
          info: 'paySuccess',
          subAddonInfos: data.checkoutSubForOdoo.subAddonInfos
        })
      } else {
        reject(data.checkoutSubForOdoo.description)
      }
    } else if (errors && errors.length > 0) {
      if (errorCode == '80E00129') {
        resolve({
          info: 'noInfo'
        })
      }
    }
  }).catch(error => {
    console.log(error)
    reject(error)
  })
})

export const addNewPlanGraphql = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: addNewPlan,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}

export const deletePlanGraphql = (params) => {
  return Apollo.defaultClient.mutate({
    mutation: deletePlanGQL,
    variables: params,
    fetchPolicy: 'no-cache'
  })
}
